import "./SecondaryButton.scss";

export default function SecondaryButton({
  type,
  children,
  onClick,
  className,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`button button--secondary ${className}`}
    >
      {children}
    </button>
  );
}
